import React, {Component} from 'react';
import {Table, Modal, Image, Button} from 'react-bootstrap';
import PatientRefundStatusChange from '../PatientPayment/PatientRefundStatusChange';
import {appConfig} from '../../../config';
var dateFormat = require('dateformat');
class PatientPaymentView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPatientRefundView: false,
    };
  }

  handlePatientPaymentRefundView = data => {
    this.setState({
      showPatientRefundView: true,
      PatientPaymentrefundDtls: data,
    });
  };
  handleCloseActive = () => {
    this.setState({showPatientRefundView: false});
  };

  render() {
    const data =
      this.props.PatientPaymentDtls && this.props.PatientPaymentDtls.item
        ? this.props.PatientPaymentDtls && this.props.PatientPaymentDtls.item
        : null;

    return (
      <div>
        <div>
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{fontSize: '35px', backgroundColor: '#f0f3f5'}}
              closeButton
            >
              <Modal.Title>
                <span style={{fontSize: '20px'}}>Patient Payment Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div>
                <div className="feedbkModalTbl">
                  <Table responsive bordered className="cmnMainTable">
                    <tbody>
                      <tr>
                        <td className="feedbkTdWdth">Reference Number</td>
                        <td className="storeModalCap">
                          {data !== null && data.invNo}
                        </td>
                      </tr>

                      <tr>
                        <td>Order ID</td>
                        <td className="storeModalCap">
                          {data !== null && data.orderId.orderNo}
                        </td>
                      </tr>
                      <tr>
                        <td>Chemist</td>
                        <td className="storeModalCap">
                          {data !== null &&
                            data.recptDtls &&
                            data.recptDtls.name}
                        </td>
                      </tr>
                      <tr>
                        <td>Customer Name</td>
                        <td className="storeModalCap">
                          {data !== null &&
                            data.orderId &&
                            data.orderId.orderFromName}
                        </td>
                      </tr>
                      {data !== null &&
                        data.status === 'paid' &&
                        <tr>
                          <td>Payment Id</td>
                          <td className="storeModalCap">
                            {data !== null && data.razorPaymentId}
                          </td>
                        </tr>}
                      {/* <tr>
                        <td>Voucher No.</td>
                        <td className="storeModalCap">
                          {data !== null && data.vouchrNo}
                        </td>
                      </tr>
                      <tr>
                        <td>Voucher Date</td>
                        <td className="storeModalCap">
                          {data !== null &&
                            data.vouchrDate != null &&
                            dateFormat(data.vouchrDate, "mediumDate")}
                        </td>
                      </tr> 
                      <tr>
                        <td>Paid Date</td>
                        <td className="storeModalCap">
                          {data !== null &&
                            data.paidDate != null &&
                            dateFormat(data.paidDate, "mediumDate")}
                        </td>
                      </tr>*/}
                      <tr>
                        <td>Amount</td>
                        <td className="storeModalCap">
                          {data !== null && data.paidAmnt}
                        </td>
                      </tr>
                      {/*<tr>
                        <td>Pay Mode</td>
                        <td className="storeModalCap">
                          {data !== null && data.payMode}
                        </td>
                      </tr>
                        <tr>
                        <td>Org Id</td>
                        <td className="storeModalCap">
                              {data !== null && data.orgId.n}
                            </td>
                      </tr> */}
                      <tr>
                        <td>Payment Status</td>
                        <td className="storeModalCap">
                          {data !== null && data.status}
                        </td>
                      </tr>
                      <tr>
                        <td> Created Date</td>
                        <td className="feedbkModalCap">
                          {data !== null &&
                            data.createdAt !== null &&
                            dateFormat(data.createdAt, 'mediumDate')}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer style={{backgroundColor: '#f0f3f5'}}>
              {data !== null && data.status === 'paid'
                ? <div>
                    <Button
                      style={{marginRight: '30px'}}
                      onClick={() =>
                        this.handlePatientPaymentRefundView({
                          data: data,
                        })}
                    >
                      <span style={{fontWeight: 'bold'}}>Refund</span>
                    </Button>
                  </div>
                : null}
               <PatientRefundStatusChange
                show={this.state.showPatientRefundView}
                handleClose={this.handleCloseActive}
                PatientPaymentrefundDtls={this.state.PatientPaymentrefundDtls}
                refreshParams={this.props.refreshParams}
                PatientRefundStatusChange={this.props.PatientRefundStatusChange}
              />
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default PatientPaymentView;
